import { PercentageChangeValues, PercentageChangeResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculatePercentageChange(
  values: PercentageChangeValues,
  t?: ToolsTranslations['percentageChange']
): PercentageChangeResult {
  const { initial, final } = values;

  if (initial < 0) return { percentChange: null, isValid: false, message: t?.invalid.initial };
  if (final < 0) return { percentChange: null, isValid: false, message: t?.invalid.final };
  if (initial === 0) return { percentChange: null, isValid: false, message: t?.invalid.initialZero };

  const raw = ((final - initial) / initial) * 100;
  const percentChange = Math.round(raw * 100) / 100; // two decimals

  if (!isFinite(percentChange)) {
    return { percentChange: null, isValid: false, message: t?.invalid.generic };
  }

  return { percentChange, isValid: true };
}
